__turbopack_context__.v({
  "author": "_EGcIW_author",
  "authorInfo": "_EGcIW_authorInfo",
  "authorPhoto": "_EGcIW_authorPhoto",
  "name": "_EGcIW_name",
});
